$(document).one('turbo:load', function () {
	if (!$('.inbox.index').length) return;
	if (window.inboxPollingInitialized) return;
	window.inboxPollingInitialized = true;
	$('#chat_window_container').on('scroll', function () {
		if ($('#chat_window_container').prop('scrollTop') == 0 && $('#chat_box_input').attr('data-disable-old-message-load') === 'false') {
			loadMessageIfTopOfScreen()
		}
	});
	// Load older messages when scrolling up.
	// setInterval(loadMessageIfTopOfScreen, 750);
	// setTimeout(checkForNewMessages, 10000);

	// When clicking on "Enter" key, it will send a message, but if shift is held down, it will insert a newline.
	$('#chat_box_input').on('keyup', function (e) {
		if (e.keyCode === 13 && e.shiftKey) {
			e.preventDefault();
		} else if (e.keyCode === 13) {
			sendMessageAndRetrieveMessages($(this), true);
		}
	});

	$('#send-chat-btn').click(function (event) {
		sendMessageAndRetrieveMessages($('#chat_box_input'), true);
	});

	// Refresh for new messages every 5 seconds.
	// setTimeout(refreshMessages, 5000);
});

function loadMessageIfTopOfScreen() {
	if ($('#chat_window_container').prop('scrollTop') < 10 && $('#chat_box_input').attr('data-disable-old-message-load') === 'false') {
		loadOlderMessages();
	}
}

function loadOlderMessages() {
	input = $('#chat_box_input');
	chat_id = input.attr('data-group-id');

	if (chat_id.includes('new:')) {
		return false
	}

	first_message = $('#chat_window_container div.message_bubble_parent[data-has-id="true"]').first().attr('data-message-id');
	oldest_message = input.attr('data-oldest-message-id');
	retrieve_url = 'inbox/' + chat_id + '/load_older_messages';

	if (input.attr('data-loading-old-message') === 'true' || first_message === oldest_message) {
		return false;
	}

	input.attr('data-loading-old-message', true);
	ajaxToRetrieveOlderMessages(retrieve_url, first_message, input);
}

function ajaxToRetrieveOlderMessages(retrieve_url, first_message, input) {
	$.ajax({
		url: retrieve_url,
		type: 'POST',
		data: { first_message: first_message }
	})
		.done(function (response) {
			if (response.logged_out) {
				popupAlert('Cannot load messages. You have been logged out. Please login and try again');
			} else {
				$('#chat_window_container div.message_bubble_parent').slice(0, 2).remove();
				$('#chat_window_container').prepend(response);
				input.attr('data-loading-old-message', false);
				original_scroll = $('#chat_window_container div.message_bubble_parent[data-message-id="' + first_message + '"]');
				$('#chat_window_container').scrollTop(original_scroll.offset().top - 100);
			}
		});
}

function checkForNewMessages() {
	checkForUnreadMessages();
	// setTimeout(checkForNewMessages, 10000);
}

function checkForUnreadMessages() {
	chats = $('.chat_list_tab').map(function (index, tab) {
		return [$(tab).attr('data-chat-id') + 'last_message-' + $(tab).attr('data-last-message-id')];
	}).get();

	$.ajax({
		url: 'inbox/47/check_for_unread_messages',
		type: 'POST',
		data: { chats: chats }
	})
		.done(function (response) {
			if (response.logged_out) {
				popupAlert('Cannot load messages. You have been logged out. Please login and try again');
			} else {
				$(response).find('.chat_list_tab').each(function (index) {
					id = $(this).data('chat-id');
					$('#chat_list_contacts .chat_list_tab[data-chat-id="' + id + '"]').remove();
					$('#chat_list_contacts').prepend($(this));
					bindChatListTab($('.chat_list_tab[data-chat-id="' + id + '"]'));
				});

				if ($(response).find('.chat_list_tab').length > 0) {
					document.getElementById('chatroom_notification_receive').play();
					active = $('#chat_box_input').attr('data-group-id');
					$('.chat_list_tab[data-chat-id="' + active + '"]').addClass('active');
				}
			}
		});
}

function refreshMessages() {
	sendMessageAndRetrieveMessages($('#chat_box_input'));
	// setTimeout(refreshMessages, 5000);
}

// Send and/or retrieve messages. If second parameter is not set, it will be just a retrieval.
function sendMessageAndRetrieveMessages(input, sending_message = false, attachment = false) {
	chat_id = input.attr('data-group-id');

	if (!sending_message && (chat_id === undefined || chat_id.includes('new:'))) {
		return false;
	}

	if (sending_message) {
		message = input.val();
		input.val('');
	} else {
		message = '';
	}

	if (attachment) {
		message = 'Attachment'
	}

	if (input.attr('data-loading-new-message') === 'false' && (!sending_message || $.trim(message) !== '')) {
		input.attr('data-loading-new-message', true);
		ajaxCallToSendOrRetrieveMessages(chat_id, message, sending_message, input, attachment);
	}
}

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function ajaxCallToSendOrRetrieveMessages(chat_id, message, sending_message, input, attachment = false) {
	send_url = 'inbox/' + chat_id + '/send_message_and_retrieve_messages';
	last_message = $('#chat_window_container div.message_bubble_parent').last().attr('data-message-id');
	var orgID = getUrlParameter('orgID')

	var data = { message: message, last_message: last_message, organization_id: orgID, program_id: $('#program_id').text().trim() }

	var ajaxObject = {
		url: send_url,
		type: 'POST',
		data: data
	}

	if (attachment) {
		data = new FormData($('#attachment-form')[0]);

		ajaxObject = {
			url: send_url,
			type: 'POST',
			data: data,
			async: true,
			cache: false,
			contentType: false,
			enctype: 'multipart/form-data',
			processData: false,
		}
	}

	$.ajax(ajaxObject)
		.done(function (response) {
			if (response.logged_out) {
				popupAlert('Cannot load messages. You have been logged out. Please login and try again');
			} else {
				scrollToBottomWhenReceivingMessages(response, sending_message);
				playMessageNotificationSound(response, sending_message);
				input.attr('data-loading-new-message', false);
				updateNewlyCreatedGroupId(chat_id);
				newMessagePushUp();

				if (attachment) {
					$("#attachment").val('')
				}
			}
		}).fail(function () {
			popupAlert('An error has occured. Message could not be sent.');
		});
}

function scrollToBottomWhenReceivingMessages(response, sending_message) {
	chat_window = $('#chat_window_container');
	current_scroll = chat_window.prop('clientHeight') + chat_window.prop('scrollTop') + 200;
	scroll_height = chat_window.prop('scrollHeight');
	chat_window.append(response);

	if (response.length > 10 && (sending_message || current_scroll > scroll_height)) {
		scrollToBottom();
		seenMessageUpdate();
	}
}

function playMessageNotificationSound(response, sending_message) {
	if (response.length > 10 && sending_message) {
		document.getElementById('chatroom_notification_send').play();
	} else if (response.length > 10) {
		document.getElementById('chatroom_notification_receive').play();
	}
}

function updateNewlyCreatedGroupId(chat_id) {
	new_group = $('#chat_window_container').find('data#new_group');

	if (new_group.length === 1) {
		new_id = new_group.attr('group-chat-id');
		members = new_group.attr('group-chat-members');
		$('.chat_list_tab[data-chat-id="' + members + '"]').remove();
		$('#chat_box_input').attr('data-group-id', new_id);
		no_id_tab = $('.chat_list_tab[data-chat-id="' + chat_id + '"]');
		no_id_tab.attr('data-chat-id', new_id);
		new_group.remove();
		new_tab = $('#chat_window_container').find('.appendable_chat_tab');
		new_tab.detach().prependTo('#chat_list_contacts');
		bindChatListTab(new_tab);
		new_tab.removeClass('hidden');
		$('.chat_list_tab').removeClass('active');
		new_tab.addClass('active');
	}
}

// Push chat tab to top of list when receiving a new message.
function newMessagePushUp() {
	message_sent = $('#chat_window_container').find('data#message_sent');

	if (message_sent.length === 1) {
		group_id = message_sent.attr('data-group-id');
		tab = $('.chat_list_tab[data-chat-id="' + group_id + '"]');
		clone = tab.clone();
		clone.find('.message_holder').text(message_sent.attr('data-message'));
		clone.find('.datetime_placeholder').text(message_sent.attr('data-timestamp'));
		$('#chat_list_contacts').prepend(clone);
		bindChatListTab(clone);
		tab.remove();
		$('#chat_window_container').find('data#message_sent').remove();
	}
}